(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Banan-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAll() {
      document.querySelectorAll('[data-banan-popup]').forEach(initPopup);
    }

    function initPopup(popup) {
      if (popup.dataset.bananInit === '1') return;
      popup.dataset.bananInit = '1';

      var sectionId = popup.dataset.sectionId;
      var scrollPct = parseInt(popup.dataset.triggerScroll, 10) || 35;
      var frequency = popup.dataset.frequency || 'session';
      var storageKey = 'banan_popup_seen_' + sectionId;
      var storage = null;
      try {
        if (frequency === 'persistent') storage = window.localStorage;
        else if (frequency === 'session') storage = window.sessionStorage;
      } catch (e) { storage = null; }

      if (storage && storage.getItem(storageKey)) return;

      function open() {
        popup.hidden = false;
        requestAnimationFrame(function () { popup.setAttribute('data-open', 'true'); });
        document.body.style.overflow = 'hidden';
      }

      function close() {
        popup.removeAttribute('data-open');
        setTimeout(function () { popup.hidden = true; }, 320);
        document.body.style.overflow = '';
        if (storage) storage.setItem(storageKey, '1');
      }

      popup.querySelectorAll('[data-popup-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.getAttribute('data-open') === 'true') close();
      });

      var copyBtn = popup.querySelector('[data-popup-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = copyBtn.dataset.code;
          if (navigator.clipboard) {
            navigator.clipboard.writeText(code).then(function () {
              var note = popup.querySelector('[data-popup-copied]');
              if (note) {
                note.hidden = false;
                setTimeout(function () { note.hidden = true; }, 2000);
              }
            });
          }
        });
      }

      var successMsg = popup.querySelector('.banan-popup__message--success');
      var successState = popup.querySelector('[data-popup-success-state]');
      var formWrap = popup.querySelector('[data-popup-form-wrap]');
      if (successMsg && successState && formWrap) {
        formWrap.hidden = true;
        successState.hidden = false;
        open();
        return;
      }

      var triggered = false;
      function onScroll() {
        if (triggered) return;
        var scrolled = window.scrollY + window.innerHeight;
        var total = document.documentElement.scrollHeight;
        var pct = (scrolled / total) * 100;
        if (pct >= scrollPct) {
          triggered = true;
          window.removeEventListener('scroll', onScroll);
          open();
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      setTimeout(onScroll, 600);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banan-cookie-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'banan_cookie_consent';

    function init() {
      document.querySelectorAll('[data-banan-cookie]').forEach(setup);
    }

    function setup(banner) {
      if (banner.dataset.bananInit === '1') return;
      banner.dataset.bananInit = '1';

      var stored = null;
      try { stored = localStorage.getItem(STORAGE_KEY); } catch (e) {}

      if (stored === 'accepted' || stored === 'declined') {
        applyConsent(stored === 'accepted');
        return;
      }

      // show banner after a tiny delay so it doesn't jump on first paint
      setTimeout(function () {
        banner.hidden = false;
        requestAnimationFrame(function () {
          banner.setAttribute('data-open', 'true');
        });
      }, 500);

      var acceptBtn = banner.querySelector('[data-cookie-accept]');
      var declineBtn = banner.querySelector('[data-cookie-decline]');

      if (acceptBtn) acceptBtn.addEventListener('click', function () { choose(banner, true); });
      if (declineBtn) declineBtn.addEventListener('click', function () { choose(banner, false); });
    }

    function choose(banner, accepted) {
      try { localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'declined'); } catch (e) {}
      applyConsent(accepted);
      banner.removeAttribute('data-open');
      setTimeout(function () { banner.hidden = true; }, 400);
    }

    function applyConsent(accepted) {
      // Shopify Customer Privacy API
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              analytics: accepted,
              marketing: accepted,
              preferences: accepted,
              sale_of_data: accepted
            },
            function () { /* callback */ }
          );
        } catch (e) {}
      }
      // Fire a custom event so other scripts can react if needed
      document.dispatchEvent(new CustomEvent('banan:consent', { detail: { accepted: accepted } }));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
